import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-move_files",
  "use": "icon-move_files-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-move_files\"><path d=\"M896 960H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64h384l192.992 160H896a64 64 0 0 1 64 64v608a64 64 0 0 1-64 64z m0-640a32 32 0 0 0-32-32h-194.016l-192-160H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V320z m-352 96l192 160-192 160V416z m-256 128h256v64H288v-64z\" fill=\"\" p-id=\"12329\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol